"use client"

import { BellRing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BellRingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BellRingIcon = component(Icon)({ as: BellRing })
